import { render, staticRenderFns } from "./ActiveUsers.vue?vue&type=template&id=252e5c72&"
import script from "./ActiveUsers.vue?vue&type=script&lang=js&"
export * from "./ActiveUsers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveUsers.vue?vue&type=style&index=0&id=252e5c72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports